import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { PageHeading } from '../components/PageHeading';
import { CallBand } from '../components/CallBand';
import { ServiceCategoryIcon } from '../components/ServiceCategoryIcon';
import { serviceCategories } from '../data/serviceCategories';
import { usePageMeta } from '../hooks/usePageMeta';
export function Services() {
  usePageMeta('Auto Repair Services in Oak Ridge, TN | East End Automotive Repair', 'Browse auto repair services in Oak Ridge, TN — diagnostics, maintenance, brakes, A/C, engine, electrical, transmission and more. Call (865) 206-2279.');
  return <>
      <PageHeading eyebrow="What we do" title="Auto Repair Services in Oak Ridge, TN" intro="Browse by category to see what East End Automotive Repair handles. Every visit follows the same process: verify the condition, confirm the cause, explain the correction, then confirm the fix." data-id="element-742" data-mp="64y9yheg1lk2" />

      <section className="w-full bg-white py-16 lg:py-24" data-id="element-743" data-mp="16pcljztt8176">
        <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-744" data-mp="16mq8xls2avi3">
          <ul className="grid gap-6 md:grid-cols-2" data-id="element-745" data-mp="1bopacq48rice">
            {serviceCategories.map(category => <li key={category.slug} className="flex flex-col rounded-lg border border-black/10 bg-white p-6 lg:p-7" data-id="element-746" data-mp="1fopqqgawi3m3">
                <div className="flex items-start gap-3" data-id="element-747" data-mp="1pfu2z896zad8">
                  <ServiceCategoryIcon name={category.icon} className="mt-1 h-6 w-6 shrink-0 text-brand-dark" data-id="element-748" data-mp="1phevytfuyl8z" />
                  <div data-id="element-749" data-mp="1zetcsu5p1c1t">
                    <h2 className="font-display text-[21px] font-bold leading-snug tracking-tight text-ink" data-id="element-750" data-mp="1zbdvdkojrqx8">
                      <Link to={`/services/${category.slug}`} className="hover:text-brand-dark" data-id="element-751" data-mp="23cr4c3mxsa8d">
                        {category.name}
                      </Link>
                    </h2>
                    <p className="mt-1.5 text-[14.5px] leading-relaxed text-steel/70" data-id="element-752" data-mp="1ccrjeav0ocsl">
                      {category.blurb}
                    </p>
                  </div>
                </div>

                <ul className="mt-5 flex flex-wrap gap-2" data-id="element-753" data-mp="1ldfwn3cl694f">
                  {category.services.map(service => <li key={service.slug} data-id="element-754" data-mp="1h9rnwhc7x7hl">
                      <Link to={`/services/${category.slug}/${service.slug}`} className="inline-block rounded border border-black/10 bg-chalk px-2.5 py-1.5 text-[12.5px] leading-snug text-steel/80 transition-colors duration-150 ease-out hover:border-ink/40 hover:text-ink" data-id="element-755" data-mp="1vaklxc1qakpg">
                        {service.name}
                      </Link>
                    </li>)}
                </ul>

                <Link to={`/services/${category.slug}`} className="mt-auto flex items-center gap-1.5 pt-6 text-[12.5px] font-bold uppercase tracking-[0.08em] text-brand-dark hover:underline" data-id="element-756" data-mp="2dyz9tqgr1im1">
                  View {category.name}
                  <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-757" data-mp="2xl16b5vl6j8q" />
                </Link>
              </li>)}
          </ul>
        </div>
      </section>

      <CallBand heading="Tell us what your vehicle is doing." copy="The fastest way to get an answer is a phone call during business hours, Monday through Friday, 8:00 AM to 5:00 PM." secondary={{
      label: 'See Current Specials',
      to: '/specials'
    }} data-id="element-758" data-mp="29x15fd4k9cgf" />
    </>;
}